// src/components/ScrollToTop.tsx
import { useLayoutEffect, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  // prevent browser restoring old positions on navigation/back-forward
  useEffect(() => {
    const prev = window.history.scrollRestoration;
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    return () => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = prev as ScrollRestoration;
      }
    };
  }, []);

  useLayoutEffect(() => {
    // temporarily disable any global smooth scrolling
    const root = document.documentElement;
    const prev = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';

    if (hash) {
      // jump to an in-page anchor if present
      const id = hash.startsWith('#') ? hash.slice(1) : hash;
      const el = document.getElementById(id) || document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ block: 'start', inline: 'nearest' }); // instant due to 'auto'
      } else {
        window.scrollTo(0, 0);
      }
    } else {
      // default: jump to top
      window.scrollTo(0, 0);
    }

    // restore smooth behavior after first paint
    requestAnimationFrame(() => {
      root.style.scrollBehavior = prev;
    });
  }, [pathname, hash]);

  return null;
}
